interface IWorldZoomProps {
  panTo: Function;
}

function WorldZoom({ panTo }: IWorldZoomProps) {
  return (
    <button
      className="worldZoom"
      onClick={() => {
        panTo({
          lat: 20,
          lng: -4,
          zoom: 3,
        });
      }}
    >
      <p>Reset map to default location</p>
    </button>
  );
}

export default WorldZoom;
